import { BR } from "./BR";
import { ES } from "./ES";

const lang = BR;

export default lang;
